var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfetti(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.614,
    height: 16,
    viewBox: "0 0 16.614 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "confetti",
    transform: "translate(-2.999 -1.978)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28433",
    "data-name": "Path 28433",
    d: "M9.972,2.121a.631.631,0,0,1,.209.867.547.547,0,0,0,.08.672l.082.082a1.9,1.9,0,0,1,.475,1.893.631.631,0,1,1-1.208-.365.638.638,0,0,0-.16-.636l-.082-.082A1.809,1.809,0,0,1,9.1,2.331.631.631,0,0,1,9.972,2.121Z",
    transform: "translate(-0.928 -0.008)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28434",
    "data-name": "Path 28434",
    d: "M17.065,4.719a.631.631,0,0,1,.495.742l-.121.606a2.368,2.368,0,0,1-1.573,1.782,1.107,1.107,0,0,0-.735.833l-.121.606a.631.631,0,1,1-1.237-.247l.121-.606a2.369,2.369,0,0,1,1.574-1.782,1.107,1.107,0,0,0,.735-.833l.121-.606A.631.631,0,0,1,17.065,4.719Z",
    transform: "translate(-1.709 -0.433)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28435",
    "data-name": "Path 28435",
    d: "M20.679,13.307a.852.852,0,0,0-.906.143,2.114,2.114,0,0,1-2.459.249l-.179-.1a.631.631,0,0,1,.631-1.093l.179.1a.852.852,0,0,0,.991-.1,2.114,2.114,0,0,1,2.249-.355l.245.107a.631.631,0,0,1-.505,1.156Z",
    transform: "translate(-2.196 -1.588)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28440",
    "data-name": "Path 28440",
    d: "M6.761,18.174c-1.9.627-2.9.89-3.459.335-.614-.614-.226-1.777.549-4.1l1.421-4.263c.532-1.595.844-2.532,1.365-2.912l0,.022-.026.131c-.022.114-.053.278-.09.482-.074.409-.17.98-.261,1.631a22.606,22.606,0,0,0-.262,4.254,22.677,22.677,0,0,0,.366,2.557c.075.39.146.731.2.976.026.122.048.22.064.288l.018.078Z",
    transform: "translate(0 -0.835)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28441",
    "data-name": "Path 28441",
    d: "M12.91,17.225l.224-.075c1.933-.644,2.9-.967,3.079-1.729s-.54-1.483-1.981-2.923l-1.421-1.421,0,.012c-.016.052-.04.129-.069.225-.058.193-.135.463-.212.77a8.76,8.76,0,0,0-.3,1.918,8.761,8.761,0,0,0,.3,1.918c.077.308.154.578.212.77.029.1.053.173.069.225l.019.059,0,.014v0Z",
    transform: "translate(-1.466 -1.446)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28442",
    "data-name": "Path 28442",
    d: "M8.678,7.465l.043-.206a12.436,12.436,0,0,1,2,1.791l.423.423-.179.538-.008.023-.022.067c-.018.058-.044.141-.075.245-.062.207-.144.5-.227.827A9.936,9.936,0,0,0,10.3,13.4a9.936,9.936,0,0,0,.338,2.223c.083.331.165.62.227.827.031.1.057.187.075.245l.022.067.086.26-2.284.761-.09-.386,0-.019L8.652,17.3c-.015-.065-.036-.159-.061-.278-.051-.237-.121-.569-.193-.946a21.5,21.5,0,0,1-.346-2.4,21.43,21.43,0,0,1,.253-4c.089-.631.182-1.186.254-1.583.036-.2.066-.357.087-.465l.024-.124.006-.031,0-.008Z",
    transform: "translate(-0.799 -0.839)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28443",
    "data-name": "Path 28443",
    d: "M14.484,2.173a.592.592,0,0,1,.7.7,3.081,3.081,0,0,1-.1.4l-.03.106.054.086a2.855,2.855,0,0,1,.2.353.633.633,0,0,1,0,.561.646.646,0,0,1-.451.32,3.039,3.039,0,0,1-.41.05l-.107.008h-.009l-.077.094a3.17,3.17,0,0,1-.278.311.643.643,0,0,1-.525.188A.622.622,0,0,1,13,5.019a2.874,2.874,0,0,1-.158-.375l-.034-.092-.092-.034a2.865,2.865,0,0,1-.375-.158A.621.621,0,0,1,12,3.9a.642.642,0,0,1,.188-.525A3.181,3.181,0,0,1,12.5,3.1l.094-.077V3.013l.008-.107a3.04,3.04,0,0,1,.05-.41.646.646,0,0,1,.32-.451.633.633,0,0,1,.56,0,2.844,2.844,0,0,1,.353.2l.086.054.106-.03A3.079,3.079,0,0,1,14.484,2.173Z",
    transform: "translate(-1.43 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28444",
    "data-name": "Path 28444",
    d: "M21.562,9.915a1.166,1.166,0,0,0-.576-2.058,1.166,1.166,0,0,0-2.058-.576,1.49,1.49,0,0,0-.379.805,3.545,3.545,0,0,0-.034.83,6.034,6.034,0,0,0,.083.671c.016.087.03.158.041.208l.013.059a.46.46,0,0,0,.313.331h0l.023.005.059.013c.05.011.121.026.208.041a6.053,6.053,0,0,0,.671.083,3.545,3.545,0,0,0,.83-.034A1.491,1.491,0,0,0,21.562,9.915Z",
    transform: "translate(-2.463 -0.775)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfetti);
export default __webpack_public_path__ + "static/media/confetti.2b7ddc8dce484d4fa2e86496c9f985b2.svg";
export { ForwardRef as ReactComponent };